// extracted by mini-css-extract-plugin
export default {"w-100":"-ne+3fmpoQwkm5M-GRMauA==","page_center":"Dz6kyTej3ETZTh0pNSn43g=="};